import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useEffect, useState } from 'react';

import i18n from 'FRONTEND/utils/i18n';

dayjs.extend(duration);

const intervalTime = 1000;

function useCountDown({ date }) {
  /**
   * Custom hook to manage a countdown.
   */
  const calculateTimeLeft = dayjs.duration(dayjs(date).diff(dayjs()));
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    setTimeLeft(calculateTimeLeft);
    const interval = setInterval(() => setTimeLeft(calculateTimeLeft), intervalTime);
    return () => clearInterval(interval);
  }, [date]);

  const countDown = {
    days: getDurationDetailed({ value: timeLeft.days(), single: i18n._('day and'), plurial: i18n._('days and') }),
    hours: `${timeLeft.hours()}`.padStart(2, 0),
    minutes: `${timeLeft.minutes()}`.padStart(2, 0),
  };
  return `${i18n._('in')} ${countDown.days} ${countDown.hours}h${countDown.minutes}`;
}

const getDurationDetailed = ({ value, single, plurial }) => {
  if (value === 1) {
    return `${value} ${single}`;
  }
  if (value > 1) {
    return `${value} ${plurial}`;
  }
  return '';
};

export default useCountDown;
